import React from "react";
import { useTranslation } from "react-i18next";

interface IFreeSubscriptionProps {
  currencySymbol: string;
}

export default function FreeSubscription({
  currencySymbol,
}: IFreeSubscriptionProps) {
  const { t } = useTranslation();
  return (
    <div className="d-flex justify-content-between align-items-center mb-4">
      <div className="d-flex flex-wrap align-items-center gap-3">
        <div className="fw-bold fs-2">{t("payment.Free")}</div>
        <div className="rounded bg-additional-gray p-2 fs-7 text-gray">
          {t("payment.With Ads")}
        </div>
      </div>
      <div>
        <span className="fw-bold fs-2">{currencySymbol}0</span> /{" "}
        {t("payment.month")}
      </div>
    </div>
  );
}
